import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Checkmark20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M18.5743 3.48235L7.54817 16.6087L1.46973 10.5303L2.53039 9.46963L7.45194 14.3912L17.4258 2.51756L18.5743 3.48235Z'
      fill='currentColor'
    />
  </Svg>
);

Checkmark20.displayName = 'Checkmark20';
export default Checkmark20;
